//TODO: now this is the only 'image': if there are more, have extend from a base image prototype (eg maybe legacy graphic notes) ...

var Raphael = require('raphael'),
    ShapeView = require('../shape'),
    GraphicShapeView = require('../graphic/graphic');

module.exports = ShapeView.extend({

    dontCreateButtonSet: true, // we don't want to the default delete shape button
    proportionalResize: true, //flag to resize proportionally

    // TODO: these should be subscribed to from the base shape obj, even if not used ... could use noop's
    shapeSubs: _.extend( {}, ShapeView.prototype.shapeSubs, {
        'shape.moveEnd':            'onMoveEnd',
        'shape.resizeEnd':          'resizeEnd',
        'shape.onAfterBaseScale':   'onAfterBaseShapeScale'
    }),

    _renderFromModel: function(shapeModel, scale) {

        var sm = this.shapeModel;

        // adjust the path (from the pts array used in coordinate shapes)
        var pts = sm.getAdjustedPointsArray(scale);

        // get it's bbox to more easily get the dimensions needed to draw the image (especially when dealing with rotation)
        var box = Raphael.pathBBox( Raphael.fn.getPathFromPtsArray( pts ) );

        var w = box.width,
            h = box.height;

        // ensure the stamp is printed with the original aspect ratio of the image
        // ( it could differ from width & height in page_note_info )
        // must take rotation into account for the aspect ratio !
        var oAR = sm.getOriginalImgAspectRatio ( sm.pageModel.get('rotation') % 360 ),
            ar = w / h; // this should already have rotation taken into account (no need to flip)

        if ( oAR > ar ) {
            h = w / oAR;
        } else {
            w = h * oAR;
        }

        return this.paper.image( sm.getImgUrl(), box.x , box.y , w , h ).attr({
            opacity: sm.placedOpacity
        });

    },
    _scaleShapeEl: function(scale, lastScale) {

        var C = scale / lastScale,
            el = this.el,
            attrs = el.attrs;

        el.attr({
            x: attrs.x * C,
            y: attrs.y * C,
            width: attrs.width * C,
            height: attrs.height * C
        });
    },

    onAfterBaseShapeScale: function() {
        this.resetGlow();
    },

    onMoveEnd: function() {

        var elMatrixPrimitive = this.el.matrix.split(),
            elAttrs = this.el.attrs;

        this.el.attr({
            x: elAttrs.x += elMatrixPrimitive.dx, //TODO rounding, at what?
            y: elAttrs.y += elMatrixPrimitive.dy
        }).transform('');
    },
    resizeEnd: function() {
        var box = this.el.getBBox();
        this.el.attr({
            width: box.width,
            height: box.height,
            // x and y needed for a resize coming from the north or the west
            x: box.x,
            y: box.y
        }).transform('');
    },

    makeExpandedVisibleIndicator: ShapeView.prototype._createGlow,

    // take out of the part about defaultSVGAttrsEdit and this should be fine ... (only one can be active at a time per note)
    // would only apply to exiting --- maybe dont need this concept at all; only one can be selected at a time
    // default SVG attributes also dont apply
    // note: current workflow assumes coming in from modify ...
    toggleActive: function() {

        this.el.toFront();

        // don't need to make cursor pointer,
        // not enabling select -- there's only one: select on entry into edit mode
        // autodisplay always applies to these
        // I suppose handle the select here ...

        this.channel.command( 'setSelectedShape', this.shapeModel );

    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/graphicStamp/shapeView.js
 ** module id = 300
 ** module chunks = 0
 **/